import {useMutation} from "@tanstack/react-query";
import {deleteExpedientMutationOptions} from "./delete-expedient.mutation-options";

export function useDeleteExpedient() {
  return useMutation(deleteExpedientMutationOptions());
}
